<template>
  <ts-loading-banner :loading="loading">
    <div class="ts-space-y-4 mb-4">
      <div class="row mb-2">
        <div class="col-md-6">
          <label class="required">{{
            $t('certificateOperationPrint.certificateType')
          }}</label>
          <a-select
            style="width: 100%"
            v-model="model.certificate_type_id"
            :options="certificate_types"
            :show-search="true"
            :filter-option="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            @change="onCertificateTypeChange"
          ></a-select>
          <div class="ts-flex ts-justify-start text-danger">
            {{ errors.first('certificate_type_id') }}
          </div>
        </div>
        <div
          class="col-md-6"
          v-if="
            model.certificate_type_id == 7 ||
              model.certificate_type_id == 8 ||
              model.certificate_type_id == 12
          "
        >
          <label class="required">{{
            $t('certificateOperationPrint.academicYear')
          }}</label>
          <a-select
            style="width: 100%"
            v-model.number="model.ac_year_id"
            :options="ac_year_list"
            :loading="fetching_academic_year"
            @change="acYearChange"
          ></a-select>
          <div class="validate" v-if="errors.has('ac_year_id')">
            {{ errors.first('ac_year_id') }}
          </div>
        </div>
        <div
          class="col-md-6"
          v-if="
            model.certificate_type_id != 7 &&
              model.certificate_type_id != 8 &&
              model.certificate_type_id != 12
          "
        >
          <label class="required">{{
            $t('certificateOperationPrint.mainProgram')
          }}</label>
          <a-select
            style="width: 100%"
            v-model.number="model.acp_id"
            :options="main_programs"
            :show-search="true"
            :filter-option="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            @change="onMainProgramChange"
          ></a-select>
          <div class="ts-flex ts-justify-start text-danger">
            {{ errors.first('acp_id') }}
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div
          class="col-md-6"
          v-if="
            model.certificate_type_id != 7 &&
              model.certificate_type_id != 8 &&
              model.certificate_type_id != 12
          "
        >
          <label class="required">{{
            $t('certificateOperationPrint.subProgram')
          }}</label>
          <a-select
            style="width: 100%"
            v-model.number="model.acps_id"
            :options="sub_programs"
            :show-search="true"
            :filter-option="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            @change="onSubChange"
            :disabled="!model.acp_id"
          ></a-select>
          <div class="validate" v-if="errors.has('acps_id')">
            {{ errors.first('acps_id') }}
          </div>
        </div>
        <div
          class="col-md-6"
          v-if="
            model.certificate_type_id != 7 &&
              model.certificate_type_id != 8 &&
              model.certificate_type_id != 12
          "
        >
          <label class="required">{{
            $t('certificateOperationPrint.academicYear')
          }}</label>
          <a-select
            style="width: 100%"
            v-model.number="model.ac_year_id"
            :options="ac_year_list"
            :loading="fetching_academic_year"
            @change="acYearChange"
          ></a-select>
          <div class="validate" v-if="errors.has('ac_year_id')">
            {{ errors.first('ac_year_id') }}
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div
          class="col-md-6"
          v-if="
            model.certificate_type_id != 7 &&
              model.certificate_type_id != 9 &&
              model.certificate_type_id != 12
          "
        >
          <label class="required">{{
            $t('certificateOperationPrint.term')
          }}</label>
          <a-select
            style="width: 100%"
            v-model.number="model.ac_term_id"
            :options="acTerms"
            :show-search="true"
            :loading="fetching_academic_term"
            :filter-option="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            @change="acTermChange"
          ></a-select>
          <div class="ts-flex ts-justify-start text-danger">
            {{ errors.first('ac_term_id') }}
          </div>
        </div>
        <div
          class="col-md-6"
          v-if="
            model.certificate_type_id != 4 &&
              model.certificate_type_id != 6 &&
              model.certificate_type_id != 7 &&
              model.certificate_type_id != 10 &&
              model.certificate_type_id != 9 &&
              model.certificate_type_id != 11 &&
              model.certificate_type_id != 12
          "
        >
          <label class="required">{{
            $t('certificateOperationPrint.classOperation')
          }}</label>
          <a-select
            style="width: 100%"
            v-model="model.class_id"
            :options="class_options"
            :show-search="true"
            :placeholder="$t('all')"
            :loading="fetching_class_operation"
            :filter-option="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
          ></a-select>
          <div class="validate" v-if="errors.has('class_id')">
            {{ errors.first('class_id') }}
          </div>
        </div>
        <div class="col-md-6" v-if="model.certificate_type_id == 11">
          <label class="required">{{
            $t('certificateOperationPrint.subject')
          }}</label>
          <a-select
            style="width: 100%"
            v-model="model.subject_id"
            :options="subjects"
            :show-search="true"
            :filter-option="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
          ></a-select>
          <div class="ts-flex ts-justify-start text-danger">
            {{ errors.first('subject_id') }}
          </div>
        </div>
        <div
          class="col-md-6"
          v-if="
            model.certificate_type_id == 4 ||
              model.certificate_type_id == 6 ||
              model.certificate_type_id == 10 ||
              model.certificate_type_id == 9
          "
        >
          <label>
            {{ $t('school.academic.operation.classOperation.grade') }}
            <i class="fa fa-spinner spin" v-if="filterLevel"></i>
          </label>
          <select
            class="form-control"
            v-model="model.level_id"
            :class="{ 'is-invalid': errors.has('level_id') }"
          >
            <option value>{{ $t('select') }}</option>
            <option
              v-for="(level, index) in levelResource"
              :key="index"
              :value="level.level_id"
            >
              {{ level.level_name_foreign }}
            </option>
          </select>
          <div class="invalid-feedback" v-if="errors.has('level_id')">
            {{ errors.first('level_id') }}
          </div>
        </div>
      </div>

      <!-- Level (grade_id) + Scoring Cycle (type 10) on their own row -->
      <div
        class="row mb-2"
        v-if="
          model.certificate_type_id == 4 ||
            model.certificate_type_id == 6 ||
            model.certificate_type_id == 10 ||
            model.certificate_type_id == 9
        "
      >
        <div class="col-md-6">
          <label>
            {{ $t('school.academic.operation.classOperation.level') }}
          </label>
          <select
            class="form-control"
            v-model="model.grade_id"
            :class="{ 'is-invalid': errors.has('grade_id') }"
          >
            <option value>{{ $t('select') }}</option>
            <option
              v-for="(grade, index) in grades"
              :key="index"
              :value="grade.grade_id"
            >
              {{ grade.grade_name_foreign }}
            </option>
          </select>
          <div class="invalid-feedback" v-if="errors.has('grade_id')">
            {{ errors.first('grade_id') }}
          </div>
        </div>

        <div class="col-md-6" v-if="model.certificate_type_id == 10">
          <label class="required">{{
            $t('certificateOperationPrint.scoringCycle')
          }}</label>
          <a-select
            style="width: 100%"
            v-model="model.scoring_cycle_id"
            :options="scoringCycles"
            @change="scoringCycleChange"
          ></a-select>
          <div class="validate" v-if="errors.has('scoring_cycle_id')">
            {{ errors.first('scoring_cycle_id') }}
          </div>
        </div>
      </div>

      <div class="row mb-2" v-if="model.certificate_type_id == 11">
        <div class="col-md-6">
          <label>
            {{ $t('school.academic.operation.classOperation.grade') }}
            <i class="fa fa-spinner spin" v-if="filterLevel"></i>
          </label>
          <select
            class="form-control"
            v-model="model.level_id"
            :class="{ 'is-invalid': errors.has('level_id') }"
          >
            <option value>{{ $t('select') }}</option>
            <option
              v-for="(level, index) in levelResource"
              :key="index"
              :value="level.level_id"
            >
              {{ level.level_name_foreign }}
            </option>
          </select>
          <div class="invalid-feedback" v-if="errors.has('level_id')">
            {{ errors.first('level_id') }}
          </div>
        </div>
        <div class="col-md-6">
          <label>
            {{ $t('school.academic.operation.classOperation.level') }}
          </label>
          <select
            class="form-control"
            v-model="model.grade_id"
            :class="{ 'is-invalid': errors.has('grade_id') }"
          >
            <option value>{{ $t('select') }}</option>
            <option
              v-for="(grade, index) in grades"
              :key="index"
              :value="grade.grade_id"
            >
              {{ grade.grade_name_foreign }}
            </option>
          </select>
          <div class="invalid-feedback" v-if="errors.has('grade_id')">
            {{ errors.first('grade_id') }}
          </div>
        </div>
      </div>

      <div
        class="row mb-2"
        v-show="
          model.certificate_type_id == 1 ||
            model.certificate_type_id == 2 ||
            model.certificate_type_id == 10
        "
      >
        <div class="col-md-6" v-if="model.certificate_type_id != 10">
          <label class="required">{{
            $t('certificateOperationPrint.scoringCycle')
          }}</label>
          <a-select
            style="width: 100%"
            v-model="model.scoring_cycle_id"
            :options="scoringCycles"
            @change="scoringCycleChange"
          >
          </a-select>
        </div>
        <!-- only hide cycle_value when type 1 or 2 AND scoring_cycle_id == 4 -->
        <div
          class="col-md-6"
          v-if="
            !(
              (model.certificate_type_id == 1 ||
                model.certificate_type_id == 2 ||
                model.certificate_type_id == 10) &&
              model.scoring_cycle_id == 4
            )
          "
        >
          <label class="required">{{
            $t('certificateOperationPrint.cycleValue')
          }}</label>
          <a-select
            style="width: 100%"
            v-model="model.cycle_value"
            :options="scoringCycleValues"
          >
          </a-select>
          <div class="validate" v-if="errors.has('cycle_value')">
            {{ errors.first('cycle_value') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-right">
          <ts-button
            class="btn-block"
            color="primary"
            @click.prevent="search"
            outline
            :waiting="waiting"
          >
            <i class="fas fa-search"></i> {{ $t('search') }}</ts-button
          >
        </div>
      </div>
      <fieldset>
        <legend>
          {{
            model.certificate_type_id == 7
              ? $t('certificateOperationPrint.employeeList')
              : $t('certificateOperationPrint.studentList')
          }}
        </legend>
        <ts-loading-banner :loading="fetchingStudent">
          <div class="row">
            <div
              class="col-md-6 ts-mb-2"
              v-show="
                model.certificate_type_id == 2 ||
                  model.certificate_type_id == 5 ||
                  model.certificate_type_id == 6 ||
                  model.certificate_type_id == 10 ||
                  model.certificate_type_id == 9
              "
            >
              <label class="required">{{
                $t('certificateOperationPrint.requestDate')
              }}</label>
              <a-date-picker
                v-model="model.printed_at"
                :allowClear="false"
                style="width: 100%"
                placeholder="DD-MM-YYYY"
                format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"
                @change="onChangeRequestDate"
                :class="{
                  'is-invalid': errors.has('printed_at')
                }"
              />
              <div class="invalid-feedback" v-if="errors.has('printed_at')">
                {{ errors.first('printed_at') }}
              </div>
            </div>
            <div class="col-md-6" v-if="model.certificate_type_id == 6">
              <label>{{ $t('search') }}</label>
              <a-input
                type="text"
                v-model="search_certificate"
                placeholder="card number|student name|major"
              />
            </div>
            <div
              class="col-md-6"
              v-if="
                model.certificate_type_id == 10 ||
                  model.certificate_type_id == 9
              "
            >
              <label>{{ $t('search') }}</label>
              <a-input
                type="text"
                v-model="search_certificate"
                placeholder="card number|student name|major"
              />
            </div>
            <div class="col-md-6 ts-mb-2" v-if="model.certificate_type_id == 7">
              <label>{{ $t('search') }}</label>
              <a-input
                type="text"
                v-model="search_certificate"
                placeholder="ID |Employee name"
              />
            </div>
            <div class="col-md-12">
              <a-table
                size="small"
                :columns="columns"
                v-if="model.certificate_type_id == 1"
                :data-source="studentLists"
                :scroll="{ y: 400 }"
              >
                <span slot="photo" slot-scope="text, record">
                  <img
                    class="height-30 ts-rounded"
                    v-lazy="{
                      src: photoStudent(record),
                      error: onError(record),
                      loading: require('@/assets/Rolling-1s-200px_2.svg')
                    }"
                  />
                </span>
              </a-table>
              <a-table
                size="small"
                :columns="
                  model.certificate_type_id == 2
                    ? columnAppreciations
                    : model.certificate_type_id == 5
                    ? columnTranscripts
                    : model.certificate_type_id == 9
                    ? columnType9
                    : columnAppreciations
                "
                v-if="
                  model.certificate_type_id == 2 ||
                    model.certificate_type_id == 5 ||
                    model.certificate_type_id == 9
                "
                :row-key="studentLists => studentLists"
                :data-source="studentLists"
                :row-selection="{ onChange: checkItem }"
                :scroll="{ y: 400 }"
              >
                <span slot="photo" slot-scope="text, record">
                  <img
                    class="height-30 ts-rounded"
                    v-lazy="{
                      src: photoStudent(record),
                      error: onError(record),
                      loading: require('@/assets/Rolling-1s-200px_2.svg')
                    }"
                  />
                </span>
              </a-table>
              <a-table
                size="small"
                :columns="columnAwerd"
                v-if="model.certificate_type_id == 3"
                :data-source="studentLists"
                :scroll="{ y: 400 }"
              >
                <span slot="photo" slot-scope="text, record">
                  <img
                    class="height-30 ts-rounded"
                    v-lazy="{
                      src: photoStudent(record),
                      error: onError(record),
                      loading: require('@/assets/Rolling-1s-200px_2.svg')
                    }"
                  />
                </span>
              </a-table>
              <a-table
                size="small"
                :columns="columnAcheivement"
                v-if="model.certificate_type_id == 4"
                :row-key="studentLists => studentLists.student_id"
                :data-source="studentLists"
                :row-selection="{ onChange: checkItem }"
                :scroll="{ y: 400 }"
              >
                <span slot="photo" slot-scope="text, record">
                  <img
                    class="height-30 ts-rounded"
                    v-lazy="{
                      src: photoStudent(record),
                      error: onError(record),
                      loading: require('@/assets/Rolling-1s-200px_2.svg')
                    }"
                  />
                </span>
              </a-table>
              <a-table
                size="small"
                :columns="columnAcheivement"
                v-if="model.certificate_type_id == 6"
                :row-key="studentLists => studentLists.student_id"
                :data-source="studentLists"
                :row-selection="{ onChange: checkItem }"
                :scroll="{ y: 400 }"
              >
                <span slot="photo" slot-scope="text, record">
                  <img
                    class="height-30 ts-rounded"
                    v-lazy="{
                      src: photoStudent(record),
                      error: onError(record),
                      loading: require('@/assets/Rolling-1s-200px_2.svg')
                    }"
                  />
                </span>
              </a-table>
              <!-- employee table for type 7 -->
              <a-table
                size="small"
                :columns="columnEmployee"
                v-if="model.certificate_type_id == 7"
                :row-key="employeeLists => employeeLists.staff_id"
                :data-source="employeeLists"
                :row-selection="{ onChange: checkItem }"
                :scroll="{ y: 400 }"
              >
                <span slot="photo" slot-scope="text, record">
                  <img
                    class="height-30 ts-rounded"
                    v-lazy="{
                      src: photoEmployee(record),
                      error: onError(record),
                      loading: require('@/assets/Rolling-1s-200px_2.svg')
                    }"
                  />
                </span>
                <span slot="position" slot-scope="text, record">
                  {{ record.position ? record.position.pos_name_en : '-' }}
                </span>
              </a-table>
              <!-- employee table for type 12 -->
              <a-table
                size="small"
                :columns="column12"
                v-if="model.certificate_type_id == 12"
                :row-key="employeeLists => employeeLists.staff_id"
                :data-source="employeeLists"
                :row-selection="{ onChange: checkItem }"
                :scroll="{ y: 400 }"
              >
                <span slot="photo" slot-scope="text, record">
                  <img
                    class="height-30 ts-rounded"
                    v-lazy="{
                      src: photoEmployee(record),
                      error: onError(record),
                      loading: require('@/assets/Rolling-1s-200px_2.svg')
                    }"
                  />
                </span>
                <span slot="position" slot-scope="text, record">
                  {{ record.position ? record.position.pos_name_en : '-' }}
                </span>
              </a-table>
              <!-- student table for type 8 -->
              <a-table
                size="small"
                :columns="columnType8"
                v-if="model.certificate_type_id == 8"
                :row-key="studentLists => studentLists.student_id"
                :data-source="studentLists"
                :row-selection="{ onChange: checkItem }"
                :scroll="{ y: 400 }"
              >
                <span slot="photo" slot-scope="text, record">
                  <img
                    class="height-30 ts-rounded"
                    v-lazy="{
                      src: photoStudent(record),
                      error: onError(record),
                      loading: require('@/assets/Rolling-1s-200px_2.svg')
                    }"
                  />
                </span>
              </a-table>
              <!-- student table for type 10 -->
              <a-table
                size="small"
                :columns="columnType10"
                v-if="model.certificate_type_id == 10"
                :row-key="studentLists => studentLists.student_id"
                :data-source="studentLists"
                :row-selection="{ onChange: checkItem }"
                :scroll="{ y: 400 }"
              >
                <span slot="photo" slot-scope="text, record">
                  <img
                    class="height-30 ts-rounded"
                    v-lazy="{
                      src: photoStudent(record),
                      error: onError(record),
                      loading: require('@/assets/Rolling-1s-200px_2.svg')
                    }"
                  />
                </span>
              </a-table>

              <!-- student table for type 11 -->
              <a-table
                size="small"
                :columns="columnType11"
                v-if="model.certificate_type_id == 11"
                :row-key="studentLists => studentLists.student_id"
                :data-source="studentLists"
                :row-selection="{ onChange: checkItem }"
                :scroll="{ y: 400 }"
              >
                <span slot="photo" slot-scope="text, record">
                  <img
                    class="height-30 ts-rounded"
                    v-lazy="{
                      src: photoStudent(record),
                      error: onError(record),
                      loading: require('@/assets/Rolling-1s-200px_2.svg')
                    }"
                  />
                </span>
              </a-table>
            </div>
          </div>
        </ts-loading-banner>
      </fieldset>
    </div>
    <div class="row">
      <div class="col-md-12 ts-flex ts-justify-between">
        <div class="ts-flex ts-justify-start text-danger">
          {{ errors.first('student_id_list') }}
        </div>
        <div class="ts-flex ts-justify-end ts-space-x-2">
          <ts-button @click.prevent="() => $emit('cancel')">
            {{ $t('cancel') }}
          </ts-button>
          <ts-button
            :waiting="waiting_new"
            :disabled="waiting_new"
            color="primary"
            @click.prevent="onSaveAddNew"
            >{{ $t('save_add_new') }}</ts-button
          >
          <ts-button
            :waiting="waiting"
            :disabled="waiting"
            color="primary"
            @click.prevent="onSave"
            >{{ $t('save') }}</ts-button
          >
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import { includes } from 'lodash'
import moment from 'moment'
export default {
  name: 'certificateOperationPrintForm',
  data() {
    return {
      loading: false,
      waiting: false,
      waiting_new: false,
      exporting: false,
      fetching_academic_year: false,
      fetching_academic_term: false,
      fetching_class_operation: false,
      fetchingStudent: false,
      fetching_student: false,
      fetch_level: false,
      errors: new Errors(),
      filterLevel: false,
      search_certificate: '',
      branches: [],
      scoringCycle: [],
      scoringCycleValue: [],
      ac_year_list: [],
      main_programs: [],
      sub_programs: [],
      ac_terms: [],
      class_options: [],
      students: [],
      certificate_types: [],
      levelResource: [],
      levels: [],
      dataList: [],
      allowedMonths: [],
      model: {
        printed_at: moment().format('DD-MM-YYYY'),
        scoring_cycle_id: null,
        certificate_type_id: null,
        branch_id: null,
        ac_term_id: null,
        class_id: null,
        cycle_value: null,
        ac_year_id: null,
        acp_id: null,
        acps_id: null,
        student_id_list: [],
        staff_id_list: [],
        level_id: null,
        grade_id: null,
        subject_id: null
      },
      boyPhoto: require('@/assets/student-default-boy.png'),
      girlPhoto: require('@/assets/student-default-girl.png')
    }
  },
  computed: {
    ...mapState('reportAcademic', ['studentStatus']),
    // 1 honorable
    columns() {
      return [
        {
          width: 20
        },
        {
          title: this.$t('certificateOperationPrint.photo'),
          dataIndex: 'photo',
          key: 'photo',
          scopedSlots: { customRender: 'photo' },
          width: 100
        },
        {
          title: this.$t('certificateOperationPrint.cardNumber'),
          dataIndex: 'card_number',
          width: 120
        },
        {
          title: this.$t('certificateOperationPrint.studentName'),
          dataIndex: 'student_name',
          width: 250
        },
        {
          title: this.$t('certificateOperationPrint.rank'),
          dataIndex: 'ranks',
          width: 70
        }
      ]
    },
    // 2 appreciatoin
    columnAppreciations() {
      return [
        {
          width: 20
        },
        {
          title: this.$t('certificateOperationPrint.photo'),
          dataIndex: 'photo',
          key: 'photo',
          scopedSlots: { customRender: 'photo' },
          width: 100
        },
        {
          title: this.$t('certificateOperationPrint.cardNumber'),
          dataIndex: 'card_number',
          width: 120
        },
        {
          title: this.$t('certificateOperationPrint.studentName'),
          dataIndex: 'student_name',
          width: 250
        },
        {
          title: this.$t('certificateOperationPrint.skill'),
          dataIndex: 'comp_item_name',
          width: 180
        }
      ]
    },
    // 3 columnAwerd
    columnAwerd() {
      return [
        {
          width: 20
        },
        {
          title: this.$t('certificateOperationPrint.photo'),
          dataIndex: 'photo',
          key: 'photo',
          scopedSlots: { customRender: 'photo' },
          width: 100
        },
        {
          title: this.$t('certificateOperationPrint.cardNumber'),
          dataIndex: 'card_number',
          width: 120
        },
        {
          title: this.$t('certificateOperationPrint.sex'),
          dataIndex: 'sex',
          width: 120
        },
        {
          title: this.$t('certificateOperationPrint.studentName'),
          dataIndex: 'student_name',
          width: 250
        },
        {
          title: this.$t('certificateOperationPrint.rank'),
          dataIndex: 'ranks',
          width: 70
        }
      ]
    },
    // 4 acheivement
    columnAcheivement() {
      return [
        {
          width: 20
        },
        {
          title: this.$t('certificateOperationPrint.photo'),
          dataIndex: 'photo',
          key: 'photo',
          scopedSlots: { customRender: 'photo' },
          width: 100
        },
        {
          title: this.$t('certificateOperationPrint.cardNumber'),
          dataIndex: 'card_number',
          width: 120
        },
        {
          title: this.$t('certificateOperationPrint.studentName'),
          dataIndex: 'student_name',
          width: 250
        },
        {
          title: this.$t('certificateOperationPrint.level'),
          dataIndex: 'grade_name_foreign',
          width: 180
        }
      ]
    },
    // 5 transcript
    columnTranscripts() {
      return [
        {
          width: 20
        },
        {
          title: this.$t('certificateOperationPrint.photo'),
          dataIndex: 'photo',
          key: 'photo',
          scopedSlots: { customRender: 'photo' },
          width: 100
        },
        {
          title: this.$t('certificateOperationPrint.cardNumber'),
          dataIndex: 'card_number',
          width: 120
        },
        {
          title: this.$t('certificateOperationPrint.studentName'),
          dataIndex: 'student_name',
          width: 250
        },
        {
          title: this.$t('certificateOperationPrint.level'),
          dataIndex: 'class_name',
          width: 180
        }
      ]
    },
    // 7 semester appreciation letter for teacher and staff
    columnEmployee() {
      return [
        {
          width: 20
        },
        {
          title: this.$t('certificateOperationPrint.photo'),
          dataIndex: 'photo',
          key: 'photo',
          scopedSlots: { customRender: 'photo' },
          width: 100
        },
        {
          title: this.$t('certificateOperationPrint.id'),
          dataIndex: 'id_number',
          width: 120
        },
        {
          title: this.$t('certificateOperationPrint.employeeName'),
          dataIndex: 'name_en',
          width: 250
        },
        {
          title: this.$t('certificateOperationPrint.position'),
          dataIndex: 'position',
          key: 'position',
          scopedSlots: { customRender: 'position' },
          width: 180
        }
      ]
    },
    // 8 - simple student list by year/term/class
    columnType8() {
      return [
        { width: 20 },
        {
          title: this.$t('certificateOperationPrint.photo'),
          dataIndex: 'photo',
          key: 'photo',
          scopedSlots: { customRender: 'photo' },
          width: 100
        },
        {
          title: this.$t('certificateOperationPrint.cardNumber'),
          dataIndex: 'card_number',
          width: 120
        },
        {
          title: this.$t('certificateOperationPrint.studentName'),
          dataIndex: 'student_name',
          width: 250
        }
      ]
    },
    // 9 transcript yearly
    columnType9() {
      return [
        {
          width: 20
        },
        {
          title: this.$t('certificateOperationPrint.photo'),
          dataIndex: 'photo',
          key: 'photo',
          scopedSlots: { customRender: 'photo' },
          width: 100
        },
        {
          title: this.$t('certificateOperationPrint.cardNumber'),
          dataIndex: 'card_number',
          width: 120
        },
        {
          title: this.$t('certificateOperationPrint.studentName'),
          dataIndex: 'student_name',
          width: 250
        },
        {
          title: this.$t('certificateOperationPrint.level'),
          dataIndex: 'level_name_foreign',
          width: 180
        }
      ]
    },

    // 10 main program, sub program, academic year, term, and grade only
    columnType10() {
      return [
        {
          width: 20
        },
        {
          title: this.$t('certificateOperationPrint.photo'),
          dataIndex: 'photo',
          key: 'photo',
          scopedSlots: { customRender: 'photo' },
          width: 100
        },
        {
          title: this.$t('certificateOperationPrint.cardNumber'),
          dataIndex: 'card_number',
          width: 120
        },
        {
          title: this.$t('certificateOperationPrint.studentName'),
          dataIndex: 'student_name',
          width: 250
        },
        {
          title: this.$t('certificateOperationPrint.level'),
          dataIndex: 'grade_name_foreign', // Displays the Grade level name
          width: 180
        }
      ]
    },
    columnType11() {
      return [
        { width: 20 },
        {
          title: this.$t('certificateOperationPrint.photo'),
          dataIndex: 'photo',
          key: 'photo',
          scopedSlots: { customRender: 'photo' },
          width: 100
        },
        {
          title: this.$t('certificateOperationPrint.cardNumber'),
          dataIndex: 'card_number',
          width: 120
        },
        {
          title: this.$t('certificateOperationPrint.studentName'),
          dataIndex: 'student_name',
          width: 250
        },
        {
          title: this.$t('certificateOperationPrint.subject'),
          dataIndex: 'subject_name_native',
          width: 180
        }
      ]
    },
    // 12 semester appreciation letter for teacher and staff
    column12() {
      return [
        {
          width: 20
        },
        {
          title: this.$t('certificateOperationPrint.photo'),
          dataIndex: 'photo',
          key: 'photo',
          scopedSlots: { customRender: 'photo' },
          width: 100
        },
        {
          title: this.$t('certificateOperationPrint.id'),
          dataIndex: 'id_number',
          width: 120
        },
        {
          title: this.$t('certificateOperationPrint.employeeName'),
          dataIndex: 'name_en',
          width: 250
        },
        {
          title: this.$t('certificateOperationPrint.position'),
          dataIndex: 'position',
          key: 'position',
          scopedSlots: { customRender: 'position' },
          width: 180
        }
      ]
    },
    grades() {
      this.model.grade_id = ''
      if (this.levelResource.length > 0) {
        let level = this.levelResource.filter(
          l => l.level_id === this.model.level_id
        )
        if (level.length > 0) {
          return level[0].grades
        }
      }

      return []
    },
    scoringCycles() {
      if (this.model.acps_id) {
        let scoring_cyles = this.sub_programs.find(
          el => el.value == this.model.acps_id
        ).scoring_cyles
        return this.scoringCycle.filter(el => includes(scoring_cyles, el.value))
      }
      return this.scoringCycle
    },
    // scoringCycleValues() {
    //   if (this.model.scoring_cycle_id) {
    //     return this.scoringCycleValue.filter(
    //       s => s.scoring_cycle_id == this.model.scoring_cycle_id
    //     )
    //   }
    //   return this.scoringCycleValue
    // },
    scoringCycleValues() {
      let values = this.scoringCycleValue
      if (this.model.scoring_cycle_id) {
        values = values.filter(
          s => s.scoring_cycle_id == this.model.scoring_cycle_id
        )
      }
      if (this.model.scoring_cycle_id == 1 && this.allowedMonths.length > 0) {
        values = values.filter(s =>
          this.allowedMonths.includes(Number(s.value))
        )
      }
      return values
    },
    acTerms() {
      if (this.model.scoring_cycle_id == 4) {
        return this.ac_terms.filter(s => s.term_order == 2)
      }
      return this.ac_terms
    },
    // studentLists() {
    //   if (_.isEmpty(this.students)) return []

    //   if (this.search_certificate) {
    //     return _.orderBy(this.students, ['card_number'], ['asc']).filter(
    //       option => {
    //         if (
    //           option.card_number === null ||
    //           option.card_number === undefined ||
    //           option.student_name_en === null ||
    //           option.student_name_en === undefined
    //         )
    //           return false

    //         return (
    //           option.card_number
    //             .toLowerCase()
    //             .startsWith(this.search_certificate.toLowerCase()) ||
    //           option.student_name_en
    //             .toLowerCase()
    //             .startsWith(this.search_certificate.toLowerCase())
    //         )
    //       }
    //     )
    //   }
    //   if (this.model.certificate_type_id == 1) {
    //     return _.orderBy(this.students, ['ranks'], 'ASC')
    //   }
    //   return _.orderBy(this.students, ['card_number'], 'ASC')
    // },
    studentLists() {
      if (_.isEmpty(this.students)) return []

      // This block handles the typing search right on the frontend
      if (this.search_certificate) {
        const query = this.search_certificate.toLowerCase().trim()

        return _.orderBy(this.students, ['card_number'], ['asc']).filter(
          option => {
            const cardNumber = option.card_number
              ? option.card_number.toLowerCase()
              : ''
            const studentName = option.student_name
              ? option.student_name.toLowerCase()
              : ''
            const studentNameKh = option.student_name_kh
              ? option.student_name_kh.toLowerCase()
              : ''
            const studentNameEn = option.student_name_en
              ? option.student_name_en.toLowerCase()
              : ''

            return (
              cardNumber.includes(query) ||
              studentName.includes(query) ||
              studentNameKh.includes(query) ||
              studentNameEn.includes(query)
            )
          }
        )
      }

      // Default sorting if search box is empty
      if (
        this.model.certificate_type_id == 1 ||
        this.model.certificate_type_id == 10 ||
        this.model.certificate_type_id == 9
      ) {
        return _.orderBy(this.students, ['ranks'], 'ASC')
      }
      return _.orderBy(this.students, ['card_number'], 'ASC')
    },
    employeeLists() {
      if (_.isEmpty(this.dataList)) return []

      if (this.search_certificate) {
        return _.orderBy(this.dataList, ['staff_id'], ['asc']).filter(
          option => {
            if (
              option.staff_id === null ||
              option.staff_id === undefined ||
              option.name_en === null ||
              option.name_en === undefined
            )
              return false

            return (
              option.staff_id
                .toString()
                .toLowerCase()
                .includes(this.search_certificate.toLowerCase()) || // Changed to .includes()
              option.name_en
                .toLowerCase()
                .includes(this.search_certificate.toLowerCase()) || // Changed to .includes()
              (option.id_number &&
                option.id_number
                  .toString()
                  .toLowerCase()
                  .includes(this.search_certificate.toLowerCase())) // Changed to .includes()
            )
          }
        )
      }

      return _.orderBy(this.dataList, ['staff_id'], 'ASC')
    },
    mainProgramList() {
      if (this.model.certificate_type_id == 6) {
        return this.main_programs.filter(m => m.value !== 103)
      }
      return this.main_programs
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('reportAcademic', [
      'getBranch',
      'getYear',
      'getMainProgram',
      'getSubProgram',
      'getTerm',
      'getClass',
      'getScoringCycle',
      'getScoringCycleValue',
      'getMonthlyForSemester',
      'getSubjectBySubProgram'
    ]),
    // Fetch Data
    async fetchData() {
      this.loading = true
      await this.getBranch().then(response => {
        this.branches = response.data.map(el => ({
          value: el.branch_id,
          label: el.branch_name_en
        }))
      })
      await this.$store
        .dispatch('certificateOperationPrint/getCertificateType')
        .then(response => {
          this.certificate_types = response.data.map(el => ({
            value: el.certificate_type_id,
            label: el.certificate_type
          }))
        })

      await this.getMainProgram()
        .then(response => {
          this.main_programs = response.data.map(el => ({
            value: el.acp_id,
            label: el.acp_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
      await this.getYear()
        .then(response => {
          this.ac_year_list = _.sortBy(response.data, ['ac_status_id']).map(
            el => ({
              value: el.ac_year_id,
              label:
                el.ac_year +
                (el.ac_status_id == 1
                  ? ' ( Current ) '
                  : el.ac_status_id == 2
                  ? ' ( History ) '
                  : ' ( Next ) ')
            })
          )
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async fetchMonthlyForSemester() {
      if (
        this.model.scoring_cycle_id != 1 ||
        !this.model.acps_id ||
        !this.model.ac_term_id
      ) {
        this.allowedMonths = []
        return
      }

      const term = this.ac_terms.find(el => el.value == this.model.ac_term_id)
      const semester_order = term ? term.term_order : null

      if (!semester_order) {
        this.allowedMonths = []
        return
      }

      try {
        const response = await this.getMonthlyForSemester({
          acps_id: this.model.acps_id,
          semester_order: semester_order
        })

        const months = response.data && response.data.months
        this.allowedMonths = Array.isArray(months)
          ? months.map(Number)
          : months
          ? String(months)
              .split(',')
              .map(Number)
          : []
      } catch (error) {
        this.allowedMonths = []
        this.$toasted.error(error.message)
      }
    },
    async onCertificateTypeChange() {
      this.model.acp_id = null
      this.model.subject_id = null
      this.subjects = []

      if (this.model.certificate_type_id == 10) {
        this.model.scoring_cycle_id = null
        this.model.cycle_value = null
        this.model.class_id = null
        this.class_options = []
      }
    },
    onChangeRequestDate(dateString) {
      this.printed_at = dateString
    },
    //onMainProgramChange
    async onMainProgramChange(acp_id) {
      this.model.acps_id = null
      await this.getSubProgram({
        filter: {
          acp_id: acp_id
        }
      })
        .then(response => {
          this.sub_programs = response.data.map(el => ({
            value: el.acps_id,
            label: el.acps_name_foreign,
            scoring_cyles: el.scoring_cyles.map(el => el.scoring_cycle_id)
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    //onSubChange
    onSubChange(acps_id) {
      this.model.ac_term_id = null
      this.model.class_id = null
      if (this.model.ac_year_id) {
        this.fetching_academic_term = true
        this.getTerm({
          filter: {
            acps_id: acps_id,
            ac_status_id: '1,2,3',
            ac_year_id: this.model.ac_year_id
          }
        })
          .then(response => {
            this.ac_terms = response.data.map(el => ({
              value: el.ac_term_id,
              term_order: el.term_order,
              label:
                el.term_name +
                (el.ac_status_id == 1
                  ? ' ( Current ) '
                  : el.ac_status_id == 2
                  ? ' ( History ) '
                  : '( Next )')
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.fetching_academic_term = false
          })
      }

      this.getScoringCycle({ acps_id: acps_id })
        .then(response => {
          this.scoringCycle = response.data
            .filter(s => {
              if (
                this.model.certificate_type_id == 1 ||
                this.model.certificate_type_id == 10
              ) {
                return [1, 3, 4].includes(s.scoring_cycle_id)
              }
              return s.scoring_cycle_id == 1
            })
            .map(el => ({
              value: el.scoring_cycle_id,
              label: el.scoring_cycle_name
            }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    //acYearChange
    acYearChange() {
      // this.model.acps_id = null
      this.model.ac_term_id = null
      this.model.class_id = null
      this.fetching_academic_term = true
      this.getTerm({
        filter: {
          acps_id: this.model.acps_id,
          ac_status_id: '1,2,3',
          ac_year_id: this.model.ac_year_id
        }
      })
        .then(response => {
          let terms = response.data
          // Special case: certificate type 3 only needs term 2 (end of year)
          if (this.model.certificate_type_id == 3) {
            terms = terms.filter(el => el.term_order == 2)
          }

          this.ac_terms = terms.map(el => ({
            value: el.ac_term_id,
            term_order: el.term_order,
            label:
              el.term_name +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                ? ' ( History ) '
                : '( Next )')
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching_academic_term = false
        })
    },
    //acTermChange
    acTermChange(ac_term_id) {
      this.term_order = this.ac_terms.find(
        el => el.value == this.model.ac_term_id
      ).term_order
      this.fetching_class_operation = true
      this.fetch_level = true
      this.model.class_id = null
      this.model.cycle_value = null
      this.getClass({
        filter: {
          ac_term_id: ac_term_id
        }
      })
        .then(response => {
          this.class_options = response.data.map(el => ({
            value: el.class_id,
            label:
              el.class_name +
              ' | ' +
              el.teacher.full_name_en +
              ' | ' +
              el.academic_study_time.study_time
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching_class_operation = false
        })

      if (this.model.scoring_cycle_id == 1) {
        this.fetchMonthlyForSemester()
      }
    },
    getLevelBySub(acps_id) {
      this.filterLevel = true
      this.model.level_id = ''
      this.$store
        .dispatch('classOperation/getLevel', acps_id)
        .then(response => {
          this.levelResource = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.filterLevel = false
        })
    },
    // scoringCycleChange
    async scoringCycleChange(scoring_cycle_id) {
      //clear student list and staff list when scoring cycle changes 
      this.students = []
      this.dataList = []
      this.model.student_id_list = []
      this.model.staff_id_list = []

      await this.getScoringCycleValue({ scoring_cycle_id: scoring_cycle_id })
        .then(response => {
          this.scoringCycleValue = response.data.map(el => ({
            value: el.scoring_cycle_value,
            label: el.scoring_cycle_description,
            scoring_cycle_id: el.scoring_cycle_id
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
      if (this.model.scoring_cycle_id == 4) {
        this.model.cycle_value = null

        if (
          this.model.certificate_type_id != 1 &&
          this.model.certificate_type_id != 10
        ) {
          this.class_options = []
          this.students = []
          this.model.ac_term_id = null
          this.model.class_id = null
        }
      } else if (
        this.model.scoring_cycle_id == 0 ||
        this.model.scoring_cycle_id == 2 ||
        this.model.scoring_cycle_id == 3 ||
        this.model.scoring_cycle_id == 6
      ) {
        const term = this.ac_terms.find(el => el.value == this.model.ac_term_id)
        this.model.cycle_value = term ? term.term_order : null
      } else {
        // scoring_cycle_id == 1 falls here
        this.model.cycle_value = null
      }
      await this.fetchMonthlyForSemester()
    },
    getSubjectsForType11(acps_id) {
      this.subjects = []
      this.model.subject_id = null
      this.$store
        .dispatch('reportAcademic/getSubjectBySubProgram', {
          filter: { acps_id: acps_id }
        })
        .then(response => {
          this.subjects = response.data.map(el => ({
            value: el.subject_id,
            label: `${el.subject_name_foreign} | ${el.subject_name_native}`
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    // search() {
    //   this.errors = new Errors()
    //   this.fetchingStudent = true
    //   this.model.student_id_list = []
    //   this.model.staff_id_list = []

    //   const action = this.model.certificate_type_id == 7
    //     ? 'certificateOperationPrint/searchEmployee'
    //     : 'certificateOperationPrint/searchStudent'

    //   this.$store
    //     .dispatch(action, this.model)
    //     .then(response => {
    //         if (this.model.certificate_type_id == 7) {
    //           this.dataList = response.data
    //           this.dataList.forEach(emp => {
    //             this.model.staff_id_list.push(emp.staff_id)
    //           })
    //         } else {
    //           this.students = response.data
    //           this.students.forEach(stu => {
    //             this.model.student_id_list.push(stu.student_id)
    //           })
    //         }
    //       })
    //     .catch(error => {
    //       this.$notify({ type: 'errors', text: error.message })
    //       this.errors = new Errors(error.errors)
    //     })
    //     .finally(() => {
    //       this.fetchingStudent = false
    //     })
    // },
    search() {
      this.errors = new Errors()
      this.fetchingStudent = true
      this.model.student_id_list = []
      this.model.staff_id_list = []

      const action =
        this.model.certificate_type_id == 7 ||
        this.model.certificate_type_id == 12
          ? 'certificateOperationPrint/searchEmployee'
          : 'certificateOperationPrint/searchStudent'

      this.$store
        .dispatch(action, this.model)
        .then(response => {
          if (
            this.model.certificate_type_id == 7 ||
            this.model.certificate_type_id == 12
          ) {
            this.dataList = response.data
            this.dataList.forEach(emp => {
              // FIX: Match the object structure used in checkItem
              this.model.staff_id_list.push({
                staff_id: emp.staff_id
              })
            })
          } else {
            this.students = response.data
            this.students.forEach(stu => {
              // FIX: Match the object structure used in checkItem
              this.model.student_id_list.push({
                student_id: stu.student_id,
                sc_item_subject_comp_id: stu.sc_item_subject_comp_id || null
              })
            })
          }
        })
        .catch(error => {
          this.$notify({ type: 'errors', text: error.message })
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.fetchingStudent = false
        })
    },
    checkItem(selectedRowKeys, selectedRows) {
      if (
        this.model.certificate_type_id == 7 ||
        this.model.certificate_type_id == 12
      ) {
        this.model.staff_id_list = []
        selectedRows.forEach(el => {
          this.model.staff_id_list.push({
            staff_id: el.staff_id ? el.staff_id : null
          })
        })
      } else {
        this.model.student_id_list = []
        selectedRows.forEach(el => {
          this.model.student_id_list.push({
            student_id: el.student_id ? el.student_id : null,
            sc_item_subject_comp_id: el.sc_item_subject_comp_id
              ? el.sc_item_subject_comp_id
              : null
          })
        })
      }
    },
    onSaveAddNew() {
      this.errors = new Errors()
      this.waiting_new = true
      this.$store
        .dispatch('certificateOperationPrint/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')

          // Clear targets, but keep the current structure for quick sequential entries
          this.clearInputForNewEntry()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    onSave() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('certificateOperationPrint/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    photoStudent(record) {
      if (record.photo) {
        return record.photo
      }

      return record.sex == 'Male' ? this.boyPhoto : this.girlPhoto
    },
    photoEmployee(record) {
      if (record.photo) {
        return record.photo
      }

      return record.gender == 1 ? this.boyPhoto : this.girlPhoto
    },
    onError(record) {
      event
        ? (event.target.src =
            record.sex == 'Male' ? this.boyPhoto : this.girlPhoto)
        : ''
    },
    clearInputForNewEntry() {
      this.students = []
      this.dataList = []

      this.model.student_id_list = []
      this.model.staff_id_list = []
      this.model.class_id = null
      this.model.cycle_value = null
      this.model.grade_id = null
      this.model.subject_id = null
      this.subjects = []

      this.search_certificate = ''
    }
  },
  watch: {
    'model.acps_id': function(value) {
      if (value) {
        this.getLevelBySub(value)
        if (this.model.certificate_type_id == 11) {
          this.getSubjectsForType11(value)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
label {
  margin-bottom: 0 !important;
}
</style>
